import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
  data?: string[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'amount-table-row',
  props: {
    modifires: { type: [String, Array, Boolean] },
    data: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_ctx.data)
    ? (_openBlock(), _createElementBlock("tr", {
        key: 0,
        class: _normalizeClass(_unref(mapModifires)('amount-table-row', _ctx.modifires))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, i) => {
          return (_openBlock(), _createElementBlock("td", {
            key: i,
            class: "amount-table-row__td"
          }, _toDisplayString(item), 1))
        }), 128))
      ], 2))
    : _createCommentVNode("", true)
}
}

})